export const PATHS_PAGE = {
  CART: '/personal/cart/',
  FAVORITES: '/favorites/',
  MAIN: '/',
  REVIEWS: '/reviews/',
};
